import { Component } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-change-biller-offer-summary',
  styleUrls: ['./change-biller-offer-summary.component.scss'],
  templateUrl: './change-biller-offer-summary.component.html',
})
export class ChangeBillerOfferSummaryComponent {
  constructor() {}
}
